import React from "react";
import { PlainButton } from "@jugl-web/ui-components";
import { ReactComponent as ArrowIcon } from "./assets/arrow.svg";
import { ReactComponent as FileIcon } from "./assets/file.svg";
import { ReactComponent as TrashIcon } from "./assets/trash.svg";
import { AgentKnowledgeContentHeader } from "../../../AgentKnowledgeContentHeader";

export const FileKnowledgePreview: React.FC<{
  title: string;
  content: string;
  onDelete: () => void;
  onRequestClose: () => void;
}> = ({ title, content, onRequestClose, onDelete }) => (
  <div className="flex h-full w-full flex-col bg-white">
    <AgentKnowledgeContentHeader
      icon={<FileIcon />}
      title={title}
      startContent={
        <PlainButton
          className="flex h-6 w-10 shrink-0 items-center justify-center"
          onClick={onRequestClose}
        >
          <ArrowIcon />
        </PlainButton>
      }
      endContent={
        <PlainButton
          className="flex h-6 w-10 shrink-0 items-center justify-center"
          onClick={onDelete}
        >
          <TrashIcon />
        </PlainButton>
      }
    />
    <div className="jugl__custom-scrollbar overflow-y-auto px-10 py-8">
      {content}
    </div>
  </div>
);
